import { render, staticRenderFns } from "./AssignVehicle.vue?vue&type=template&id=366da4ba&scoped=true"
import script from "./AssignVehicle.vue?vue&type=script&lang=js"
export * from "./AssignVehicle.vue?vue&type=script&lang=js"
import style0 from "./AssignVehicle.vue?vue&type=style&index=0&id=366da4ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366da4ba",
  null
  
)

export default component.exports